export const setGA4EcommerceEvent = (eventName: string, ecommerce: any) => {
    /**
     * Reference: https://developers.google.com/analytics/devguides/collection/ga4/reference/events#view_item
     * The first step is 'Clear the previous ecommerce object.'
     */
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
        event: eventName,
        ecommerce: ecommerce
    });
};